// extracted by mini-css-extract-plugin
module.exports = {"savedAssetsDisplayFlex":"styles_savedAssetsDisplayFlex__2z-kj"};